import PackageIconDuotone from '@/components/icons/PackageIconDuotone';
import { t } from 'i18next';

const OrdersInfoListEmpty = () => {
	return (
		<div className='h-full flex-1 flex flex-col items-center justify-center gap-2'>
			<PackageIconDuotone className='size-8' />
			<div className='w-80 flex flex-col gap-1 text-center'>
				<h3 className='text-lg font-medium'>
					{t('main.orders.components.pageEmpty.title')}
				</h3>
				<p className='text-sm text-popover-600'>
					{t('main.orders.components.pageEmpty.description')}
				</p>
			</div>
		</div>
	);
};

export default OrdersInfoListEmpty;
